import type {
  DirectorProfile,
  PublicDirectorProfile,
  UpdateDirectorProfileRequest,
} from '@swiss-magic/shared-types';
import { del, get, postFormData, publicGet, put } from './core';

export function getDirectorProfile(): Promise<DirectorProfile> {
  return get('/director/profile');
}

export function updateDirectorProfile(
  patch: UpdateDirectorProfileRequest,
): Promise<DirectorProfile> {
  return put('/director/profile', patch);
}

export function getPublicDirectorProfile(
  userId: string,
): Promise<PublicDirectorProfile> {
  return publicGet(`/public/director-profile/${userId}`);
}

export function uploadDirectorLogo(file: File): Promise<DirectorProfile> {
  const form = new FormData();
  form.append('file', file);
  return postFormData<DirectorProfile>('/director/profile/logo', form);
}

export function deleteDirectorLogo(): Promise<DirectorProfile> {
  return del<DirectorProfile>('/director/profile/logo');
}
